<template>
  <QmulusLogoTypo
    v-if="variant == 'only-typo'"
  />
  <QmulusLogo
    v-else
  />
</template>

<script setup lang="ts">
import QmulusLogoTypo from '../../assets/qmulus-logo-typo.svg';
import QmulusLogo from '../../assets/qmulus-logo.svg';

withDefaults(
  defineProps<{
    variant?: 'full' | 'only-typo',
  }>(),
  {
    variant: 'full',
  },
);
</script>
